import React, { useRef } from 'react';
var VeltCommentsSidebarV2FilterDropdown = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2FilterDropdown;
